module.exports = __webpack_public_path__ + "img/winter.b02e0188.webp";